import React, { useContext, useEffect, useRef } from "react";
import { CheckCircle2, XSquare } from "lucide-react";
import * as assets from "../../../assets";
import { TranslationContext } from "../../context/TranslationContext";
import { CancelButton } from "../../CustomComponents";
import copy from "copy-to-clipboard";
import toast from "react-hot-toast";
import { Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { useCreditsConfig } from "../../../hooks/useCreditsConfig";

const ShareModal = (props) => {
  const { joiningCredits } = useCreditsConfig();
  const textRef = useRef();

  const modalRef = useRef(null);
  const {
    setShareWindow,
    encodedShareUrl,
    sharbleLink,
    encodedShareText,
    encodedEmailSubject,
    encodedEmailBody,
  } = props;
  const { contentData: CD } = useContext(TranslationContext);

  const referralCode = useSelector((state) => state.customer.referralCode);
 const fullMessage = `${encodedShareText} Here's the link: ${encodedShareUrl}`;
  const whatsappWebUrl = `https://web.whatsapp.com/send?text=${encodeURIComponent(fullMessage)}`; // IMPORTANT: Encode the fullMessage for WhatsApp
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedShareUrl}`;
  // const whatsappWebUrl = `https://web.whatsapp.com/send?text=${fullMessage}`;
  const telegramShareUrl = `https://telegram.me/share/url?url=${encodedShareUrl}&text=${encodedShareText}`;
  const gmailShareUrl = `mailto:?subject=${encodedEmailSubject}&body=${encodedEmailBody}`;

  const copyToClipboard = () => {
    let copyText = textRef.current.value;
    let isCopy = copy(copyText);
    if (isCopy) {
      toast.success("Copied to Clipboard");
    }
  };

  useEffect(() => {
    const handleOutSiteOffClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShareWindow(false);
      }
    };

    document.addEventListener("mousedown", handleOutSiteOffClick);

    return () => {
      document.removeEventListener("mousedown", handleOutSiteOffClick);
    };
  }, []);

  //    useEffect(() => {
  //     const handleOutSiteOffClick = (event) => {
  //       if (modalRef.current && !modalRef.current.contains(event.target)) {
  //         setShareWindow(false);
  //         alert('close it');
  //       }
  //     };

  //     document.addEventListener('mousedown', handleOutSiteOffClick);

  //     return () => {
  //       document.removeEventListener('mousedown', handleOutSiteOffClick);
  //     };
  //   }, []);

  return (
    <div
      className="w-[320px] md:w-[400px] py-4 pt-7 relative bg-white px-4 rounded-md "
      ref={modalRef}
    >
      <div className=" absolute right-[-1%] top-[-3%]">
        <CancelButton
          onClick={() => {
            setShareWindow(false);
          }}
        />
      </div>
      <div className=" flex flex-col ">
        <div className="flex  relative justify-between ">
          {/* <div>
                  <CheckCircle2
                     fill='#B3FFAE'
                     strokeWidth={2}
                     className="absolute left-1 top-2 lg:left-3 lg:top-2 md:top-2 md:left-2 z-[99999] cursor-pointer text-[#367E18]"
                  />
               </div>. */}
        </div>

        <div>
          <p className=" text-black font-medium  text-[16px]">
            
            Refer JaaGa to your friend to get {joiningCredits} free credits.{" "}
          </p>
        </div>

        <div className="flex flex-col space-y-1">
          <div className="w-full flex items-center gap-x-2">
            {referralCode ? (
              <>
                <input
                  value={encodedShareUrl}
                  disabled
                  type="text"
                  className="w-full text-slate-500 font-semibold  border border-slate-400 rounded-md bg-slate-100  px-2 py-2"
                  ref={textRef}
                />
                <Tooltip title="copy">
                  <img
                    src={assets.copyIcon}
                    alt="Copy Icon"
                    className="h-5 w-5 cursor-pointer hover:text-indigo-400"
                    onClick={copyToClipboard}
                  />
                </Tooltip>
              </>
            ) : (
              <h2 className=" font-semibold">{CD.CopiedLink}</h2>
            )}
          </div>
          <div className="flex text-xs flex-wrap">
            <p>{CD.expiryMsg30days}</p>
          </div>
          <div>
            <p>{CD.expiryMsg2}</p>
          </div>
          <div>
            <ul className="flex pt-1 justify-evenly gap-1">
              <li>
                <a
                  href={facebookShareUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pt-3  "
                >
                  <img src={assets.facebook} alt="facebook" />
                </a>
              </li>
              <li>
                <a href={whatsappWebUrl} target="_blank" className="pt-3  ">
                  <img src={assets.whatsapp} alt="whatsapp" />
                </a>
              </li>
              <li>
                <a
                  href={telegramShareUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pt-3  "
                >
                  <img src={assets.telegram} alt="telegram" />
                </a>
              </li>
              <li>
                <a
                  href={gmailShareUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pt-3  "
                >
                  <img src={assets.gmail} alt="gmail" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
